import { memo, useMemo } from "react";

import { routes } from "routes";
import { SeeMoreBlock } from "components/blocks/SeeMoreBlock";
import { TagLink } from "components/widgets/TagList/TagLink";
import { ITag } from "services/types";
import { useTrendingTags } from "queries";

const TrendingTagsComponent = () => {
  const { isSuccess, data } = useTrendingTags();

  const tags = useMemo(() => {
    return isSuccess && data ? data : [];
  }, [isSuccess, data]);

  return (
    <SeeMoreBlock
      header="🔥️ Trending Porn GIFs Tags"
      more={routes.trendingTags()}
      className="trendingTags canvas"
      list={true}
    >
      {tags.map((tag: ITag) => (
        <TagLink
          key={tag.name}
          tag={tag}
          counts={true}
        />
      ))}
    </SeeMoreBlock>
  );
};

export const TrendingTags = memo(TrendingTagsComponent);
